import React from 'react';
import css from './MatchingRateSection.css';
import { IconCheckCircleM, IconPauseCircleM, UpdateCircleIcon } from '../../icons';
import { useIntl } from 'react-intl';
import { getTimeDiffRepresentation } from '../../util/time';
import { LISTING_STATE_CLOSED } from '../../util/types';
import { getListingDisplayDate } from '../../util/listings';

const formatDate = (date, dateFormatConfig, intl) =>
    intl.formatDate(
        new Date(date),
        dateFormatConfig || {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }
    );

const DateRepresentation = ({ currentPageListing, isHorsePage, user, dateFormatConfig }) => {
    const intl = useIntl();
    const {
        attributes: {
            createdAt: userCreatedAt,
            profile: {
                publicData: { updatedAt: userUpdatedAt },
            },
        },
    } = user;

    const {
        attributes: {
            state: listingState,
            publicData: { updatedAt: listingUpdatedAt, listingClosedAt },
        },
    } = currentPageListing;

    const listingDate = getListingDisplayDate(currentPageListing);
    const listingIsClosed = listingState === LISTING_STATE_CLOSED;
    const listingIsUpdated = Boolean(listingUpdatedAt);

    const dateInfoAvailable = isHorsePage ? listingDate : userUpdatedAt || userCreatedAt;
    const dateIsUpdated = isHorsePage ? listingIsUpdated : Boolean(userUpdatedAt);

    if (!dateInfoAvailable) return null;

    const profileMessage = `Mitglied seit ${formatDate(dateInfoAvailable, dateFormatConfig, intl)}`;

    const { days, hours, minutes, justNow } = getTimeDiffRepresentation(
        new Date(listingIsClosed ? listingClosedAt : dateInfoAvailable),
        new Date(),
        {
            daysLongText: 'Tagen',
        }
    );

    const listingStatus = listingIsClosed
        ? 'pausiert'
        : listingIsUpdated
        ? 'aktualisiert'
        : 'veröffentlicht';

    return (
        <p className={css.createdAt}>
            {!listingIsClosed && dateIsUpdated && <UpdateCircleIcon />}
            {!listingIsClosed && !dateIsUpdated && <IconCheckCircleM />}
            {listingIsClosed && <IconPauseCircleM />}

            {!isHorsePage && <span>{profileMessage}</span>}
            {isHorsePage && (
                <span>
                    {justNow || `Vor ${days || hours || minutes || ''}`} {listingStatus}
                </span>
            )}
        </p>
    );
};
export default DateRepresentation;
